<template>
  <v-row class="text-center">
    <v-col col="12" md="12">
      <div class="text-h5 ml-2">
        <v-btn v-if="backArrow" :to="{ name: this.backArrow }" icon active-class="no-active">
          <v-icon>
            mdi-arrow-left
          </v-icon></v-btn
        >{{ text }}
        <v-btn v-if="editRouter" @click="onEditItem()" class="ma-2" tile outlined>
          <v-icon left>mdi-pencil</v-icon>
          {{ $t('edit') }}
        </v-btn>
      </div>
      <v-divider class="my-2"></v-divider>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Header',
  props: {
    text: String,
    backArrow: String,
    editRouter: String,
    id: [String, Number],
  },
  methods: {
    onEditItem() {
      this.$router.push({
        name: this.editRouter,
        query: { id: this.id },
      });
    },
  },
};
</script>

<style>
.v-application .text-h5 {
  font-size: 1.5rem !important;
  font-weight: 700;
  line-height: 2rem;
  letter-spacing: normal !important;
  font-family: 'Roboto', sans-serif !important;
}
</style>
